import api from './api';

const adminServiceCategoryService = {
  // Get all service categories (includes inactive ones for admin)
  getServiceCategories: async () => {
    try {
      const response = await api.get('/partners/admin/service-categories/');
      const data = response.data.results || response.data;
      return { success: true, data: data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch service categories'
      };
    }
  },

  // Get single service category by ID
  getServiceCategoryById: async (id) => {
    try {
      const response = await api.get(`/partners/admin/service-categories/${id}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch service category'
      };
    }
  },

  // Create new service category
  createServiceCategory: async (data) => {
    try {
      const response = await api.post('/partners/admin/service-categories/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to create service category'
      };
    }
  },

  // Update service category
  updateServiceCategory: async (id, data) => {
    try {
      const response = await api.patch(`/partners/admin/service-categories/${id}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to update service category'
      };
    }
  },

  // Delete service category
  deleteServiceCategory: async (id) => {
    try {
      await api.delete(`/partners/admin/service-categories/${id}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to delete service category'
      };
    }
  }
};

export default adminServiceCategoryService;
